import { firebaseAuth } from '../lib/firebaseClient';
import { createAuthContext } from '@rhwb/auth';
import { usageTracker } from '../lib/usageTracker';

const CLOUD_RUN_URL = process.env.REACT_APP_CLOUD_RUN_URL ?? '';

const auth = createAuthContext({
  firebaseAuth,
  cloudRunUrl: CLOUD_RUN_URL,
  appName: 'rhwb-pulse',
  appDisplayName: 'RHWB Pulse',
  onBeforeLogout: () => usageTracker.stop(),
  requireMembership: true,
});

export const AuthProvider = auth.AuthProvider;
export const useAuth = auth.useAuth;
export type { AuthUser, AuthContextType } from '@rhwb/auth';
